import { SheetValueStatus, SpreadsheetValueType } from 'core/enums';
import { ValueOf } from '../utilities';

export const SPREADSHEET_TYPES = {
  METRIC: 'METRIC',
  VIEW: 'VIEW',
} as const;

export const SPREADSHEET_STATUS = {
  ACTIVE: 'ACTIVE',
  PASSIVE: 'PASSIVE',
} as const;

export interface ScriptExecutionOptions {
  companyList?: string[];
  fromPeriod: string;
  toPeriod: string;
}

export interface SpreadsheetEntity {
  id: string;
  name: string;
  alias: string;
  description: string;
  valueType: SpreadsheetValueType;
  script: string;
  executionOpts: ScriptExecutionOptions;
  status: ValueOf<typeof SPREADSHEET_STATUS>;
  type: ValueOf<typeof SPREADSHEET_TYPES>;
  createdAt: number;
}

export type SpreadsheetSummaryEntity = Omit<SpreadsheetEntity, 'description' | 'script' | 'alias'>;

export type SheetSummaryEntity = { id: string; year: number; quarter: number; createdAt: number };

export type SheetValue = { symbol: string; value: number; status: SheetValueStatus; calculatedAt: number; errorLogs: string[] };
